import type { JwtPayload } from '@clarix/shared-types';

/** Owner = the workspace OWNER role. Drives onboarding/setup gating. */
export function isOwner(
  user: Pick<JwtPayload, 'workspace_role'> | null | undefined,
): boolean {
  return user?.workspace_role === 'OWNER';
}
